export default __webpack_public_path__ + "static/media/existing2.81bd3c91.png";